import {
  TrackEventData,
  TrackEventService,
} from '@maximizer/core/shared/data-access';

export class TrackEventsHelper {
  static outlookSyncEvent(
    trackEvent: TrackEventService,
    action: 'started' | 'enabled' | 'closed' | 'clicked' | 'completed',
    metadata?: TrackEventData['metadata'],
  ): void {
    const event: TrackEventData = {
      module: 'outlook-sync',
      journey: 'add-to-outlook-sync',
      action,
    };

    if (metadata) {
      event.metadata = metadata;
    }

    trackEvent.trackEvent(event);
  }
}
